module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-create-coupon.633971a6.png";